module.exports = __webpack_public_path__ + "2f436aa5e08ca513f152e2e54c71487a.pdf";